export var defaultProps = {
    className: '',
    disabled: false,
    size: 'normal',
    searchText: false,
    onChange: function (value, e) { },
    onBeforeEnter: function () { return true; },
    onEnter: function (e) { },
};
